//引入Vue核心库
import Vue from 'vue'
//引入Vuex
import Vuex from 'vuex'
//引用Vuex
Vue.use(Vuex)
import { pagedynamic } from './modules/dynamic';

//创建并暴露store
export default new Vuex.Store({
    modules:{
        //将store分割成模块
        pagedynamic,
    }
})